import React, { useEffect, useState } from "react";
import { ModalPadrao, LabelPadrao, InputPadrao } from "../../components/Base";
import { fetch } from "../../actions";
import { Input } from "antd";
import * as api from "./api";
import { useSave } from "../../components/Hooks/Conexao";
import Mensagens from "../../components/Mensagens";
import { connect } from "react-redux";
import SelectFiltros from "../../components/Selects/SelectFiltros";
import { BtnPadrao, BtnSair } from "../../components/Buttons";
import { InputNumero } from "../../components/InputNumero";

const INITIAL_STATE = { valor: 0 };
function Transferencia({ visible, onOk, onCancel, ...props }) {
  const [transferencia, setTransferencia] = useState(INITIAL_STATE);
  const [controller, setController] = useState(new AbortController());
  const [save, saving] = useSave(() => api.transferir(props.fetch, transferencia, controller), () => { onOk(); Mensagens.showSucesso("Transferência efetuada com sucesso!"); });

  useEffect(() => {
    if (visible) {
      setTransferencia(INITIAL_STATE);
      setController(new AbortController());
    }

    return () => {
      if (!!controller)
        controller.abort();
    };
  }, [visible]);

  const handleCancel = () => {
    if (!!controller)
      controller.abort();

    onCancel();
  };

  return <ModalPadrao
    visible={visible}
    onCancel={handleCancel}
    title="Transferência"
    width={800}
    footer={
      <>
        <BtnPadrao onClick={save} loading={saving}>Transferir</BtnPadrao>
        <BtnSair onClick={handleCancel} />
      </>}>
    <div style={{ display: "flex" }}>
      <div style={{ width: "50%" }}>
        <LabelPadrao noMargin>Empresa</LabelPadrao>
        <InputPadrao value={props.auth.empresa.fantasia} disabled />
      </div>
      <div style={{ width: "calc(25% - 10px)", margin: "0 10px" }}>
        <LabelPadrao noMargin>Número</LabelPadrao>
        <InputPadrao autoFocus placeholder="Informe o número" value={transferencia.numero} onChange={v => setTransferencia({ ...transferencia, numero: v.target.value })} disabled={saving} tabIndex={1000} />
      </div>
      <div style={{ width: "25%" }}>
        <LabelPadrao noMargin>Valor</LabelPadrao>
        <InputNumero value={transferencia.valor} onChange={v => setTransferencia({ ...transferencia, valor: v })} min={0} disabled={saving} tabIndex={1001} />
      </div>
    </div>

    <div style={{ display: "flex" }}>
      <div style={{ width: "50%", marginRight: 10 }}>
        <LabelPadrao>Caixa de origem</LabelPadrao>
        <InputPadrao value={props.auth.user} disabled />
      </div>
      <div style={{ width: "50%" }}>
        <SelectFiltros allowClear={false} title="Caixa de destino" placeholder="Selecione o caixa" modelo="usuario" value={transferencia.usuarioId} onChange={v => setTransferencia({ ...transferencia, usuarioId: v })} disabled={saving} tabIndex={1003} />
      </div>
    </div>

    <LabelPadrao>Histórico</LabelPadrao>
    <Input.TextArea placeholder="Informe o histórico" onChange={v => setTransferencia({ ...transferencia, historico: v.target.value })} disabled={saving} tabIndex={1004} />
  </ModalPadrao>;
}

const mapStateToProps = state => ({ auth: state.auth });

export default connect(mapStateToProps, { fetch })(Transferencia);